module.exports = "//static.hsappstatic.net/LoginUI/static-1.14821/img/ms-logo.png"